import { connect } from 'react-redux';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import { resolveHopintoQuery } from '@Pages/Hopinto/HopintoQuery';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { resolveUserAlert, resolveUserAlertHitDetails } from '@Containers/Hopinto/Services/Alert';
import { resolveFullText } from '@Containers/Hopinto/Services/FullText';
import { resolveAdvancedQL } from '@Containers/Hopinto/Services/AdvancedQL';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import { createRTProject } from '@Pages/Hopinto/HopintoRT';
import { createCNProject } from '@Pages/Hopinto/HopintoCN';
import { addProjectAction } from '@Pages/RetroSynthesis/RetroSynthesisProjects/actions';
import { proccessBatchFile } from '@Pages/Hopinto/HopintoBatchFile';
import every from 'lodash/every';
import isUndefined from 'lodash/isUndefined';
import { UI_DIRECTIVES } from '@Utils/UIDirectivesParameterHelper';

const resolveHopinto = (history, { addProject }) => {
  const stateParams = Object.fromEntries(new URLSearchParams(history.location.search));
  const _checkParams = (requiredParams) => every(requiredParams, (reqP) => !isUndefined(stateParams[reqP]));

  const isNewAlert = stateParams.origin === 'email-doc';
  const isNewAlertHitDetails = stateParams.forward === 'switch_from_citation';
  const isNewAlertFullText = stateParams.forward === 'follow_fulltext';
  const isAdvancedQL = stateParams?.ui?.split(UI_DIRECTIVES.DIRECTIVES_SEPARATOR)?.includes(UI_DIRECTIVES.ADVANCED_QL);
  const newAlertParams = ['alert'];
  const newAlertHitDetailsParams = ['alert', 'context', 'query'];
  const newAlertFullTextParams = ['query', 'context'];
  const batchFileParams = ['file'];
  const rtParams = ['context'];
  const cnParams = ['context', 'query'];

  // new alerts
  if (isNewAlert) {
    if (isNewAlertHitDetails && _checkParams(newAlertHitDetailsParams)) {
      // hit details
      resolveUserAlertHitDetails(stateParams);
    } else if (isNewAlertFullText && _checkParams(newAlertFullTextParams)) {
      resolveFullText(stateParams);
    } else if (_checkParams(newAlertParams)) {
      // alert
      resolveUserAlert(stateParams);
    } else {
      // default - for view document
      resolveHopintoQuery(stateParams, history.location);
    }
  } else if (_checkParams(batchFileParams)) {
    // batch file hopinto
    proccessBatchFile(stateParams);
  } else if (_checkParams(rtParams) && stateParams.context === 'RT') {
    // RT create project
    createRTProject(stateParams, history, addProject);
  } else if (_checkParams(cnParams) && stateParams.context === 'CN') {
    // CN (Condition Navigator) create project
    createCNProject(stateParams, history);
  } else if (isAdvancedQL) {
    // Texel hopinto to advanced querylet (ADVANCED.QL)
    resolveAdvancedQL(stateParams);
  } else {
    // advanced query
    resolveHopintoQuery(stateParams, history.location);
  }
};

export function HopintoContainer({ addProject }) {
  const history = useHistory();

  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
    resolveHopinto(history, { addProject });
    // eslint-disable-next-line
  }, []);

  return <SimpleSpinner />;
}

const mapDispatchToProps = {
  addProject: addProjectAction,
};

export default connect(null, mapDispatchToProps)(HopintoContainer);
